import type {ReactNode} from 'react';
import React from 'react';
import {Text, TextSize} from "@Components/text";
import styles from './event-promotion-link.module.scss';
import {GA4EventName} from "@Libraries/ga-events";

export function EventPromotionLink(): ReactNode {

  const onClick = (): void => {
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.EVENTS_CREATE_LOGIN_CLICK);
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.EVENTS_CREATE_CLICK);
    window.location.href = window.PMW.util.site_url('event/wizard');
  }

  return <div className={`${styles.linkContainer} spacing-m-t-6 spacing-m-r-6`} onClick={onClick}>
    <Text val={window.i18next.t('pmwjs_create_a_free_event')} size={TextSize.XSMALL} className={'content-body-white'} underline={true}/>
    <Text val={' 🎉'} size={TextSize.XSMALL} className={'content-body-white'}/>
  </div>
}